module.exports = __webpack_public_path__ + "static/media/presentation_pc1.f3cbef42.png";